import React from 'react';
import Button from 'react-toolbox/lib/button';
import Input from 'react-toolbox/lib/input';// to use input from react-toolbox library
import Error from 'components/ErrorMessage';// to display error messages on invalid user input
import { regExForName } from 'constants/Regularexpression'; // regular expressions to validate user input
import PropTypes from 'prop-types'; // to validate and set default props  coming to this component
import renderIf from 'render-if';// to use conditional rendering based on values that is provided to component
import { is, Map } from 'immutable'; // use of immutablejs for various js operations to simplify our work
import cn from 'classnames'; // to use global class name eg. classes from grid.css in public folder
import styles from './ParentInfo.scss';// to import local scss fle

class ParentInfo extends React.Component {

  static propTypes = {
    next: PropTypes.func.isRequired,
    show: PropTypes.bool.isRequired,
    profile: PropTypes.instanceOf(Map),
    attributes: PropTypes.shape(),
  };
  static defaultProps = {
    next: () => {},
    show: true,
    profile: Map(),
    attributes: () => {},
  };


  constructor(props) {
    super(props);
    this.state = {
      gender: 'male',
      fullname: '',
      validFullName: false,
      fullNameErrorMessage: '',
      mobileErrorMessage: '',
    };
    this.handleChange = this.handleChange.bind(this);
    this.goToNextTab = this.goToNextTab.bind(this);
    this.removeErrorMessage = this.removeErrorMessage.bind(this);
    this.handleQueryChange = this.handleQueryChange.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (!is(nextProps.attributes, this.props.attributes)) {
      this.setState({ fullname: nextProps.attributes.get('name') });
    }

    const { profile = Map() } = this.props;
    if (nextProps.profile.size > 0 && !is(profile, nextProps.profile)) {
      const newState = {
        gender: nextProps.profile.get('gender'),
        fullname: nextProps.profile.get('fullname'),
        state: nextProps.profile.get('sa_state'),
        city: nextProps.profile.get('city'),
      };
      this.setState(newState);
    }
  }

  handleChange = (name, value) => {
    this.setState({ ...this.state, [name]: value });
  };

  removeErrorMessage = (name) => {
    this.setState({ ...this.state, [name]: '' });
  };

  goToNextTab() {
    const { fullname } = this.state;

    let validFullName = false;
        /* validation for Full Name */
    const enteredFullName = regExForName.test(fullname);
    if (enteredFullName && fullname !== '') {
      validFullName = true;
    } else {
      this.setState({ fullNameErrorMessage: 'Please enter a valid name.' });
    }
        /* validation for Full Name */
    if (validFullName) {
      this.props.next(this.state);
    }
  }
  handleQueryChange(val) {
    if (!val && val.length === 0) {
      this.handleChange('state', '');
    }
  }
  render() {
    const { fullNameErrorMessage, mobileErrorMessage } = this.state;
    const renderIfShow = renderIf(this.props.show);
    return (
      <div>
        {renderIfShow(
          <div className={cn('row', styles.personalInfoContainer)}>
            <div className={cn('col s12', styles.fullWidth)}>
              <div className={fullNameErrorMessage === '' ? cn('col s12 m6', styles.halfWidthWithSpan) : cn('col s12 m6', styles.halfWidthWithSpanError)}>
                <span>FULL NAME</span>
                <Input
                  type="text"
                  name="full_name"
                  value={this.state.fullname}
                  onFocus={() => this.removeErrorMessage('fullNameErrorMessage')}
                  onChange={val => this.handleChange('fullname', val)}
                />
                <Error message={this.state.fullNameErrorMessage} />
              </div>
              <div className={mobileErrorMessage === '' ? cn('col s12 m6', styles.halfWidthAutoComplete) : cn('col s12 m6', styles.halfWidthAutoCompleteError)}>
                <span>EMAIL</span>
                <Input
                  type="text"
                  name="city"
                  value={this.props.attributes.get('email')}
                  disabled
                />
              </div>
            </div>
            <div className={cn('col s12', styles.buttonContainer)}>
              <Button label="CONTINUE" raised className={styles.continue} onClick={() => this.goToNextTab()} />
            </div>
          </div>,
                )}
      </div>

    );
  }
}

export default ParentInfo;



// WEBPACK FOOTER //
// ./src/components/ParentInfo/ParentInfo.js